<div class="box mb-2" [class.p-0]="paddingless">
  <div class="columns mb-0">
    <div class="column" [class.m-2]="paddingless" *ngIf="!!title">
      <span class="title is-size-5">{{ title }}</span>
    </div>

    <div *ngIf="showFBCodes" class="column fb-code-container">
      <div class="weight-medium">FB:&nbsp;</div>
      <div *ngFor="let fbCode of fbCodes">
        <span>{{ fbCode }}</span
        >&nbsp;
      </div>
    </div>

    <div *ngIf="exchangeFare && !exchangeFare?.isManual" class="column mdi-alert-circle-container">
      <em
        class="mdi mdi-alert-circle mdi-18px"
        aria-hidden="true"
        *ngIf="exchangeFare && !exchangeFare?.isManual"
        matTooltip="{{ 'fare.automatic-rate' | translate }}"
        matTooltipPosition="above"
      ></em>
    </div>
  </div>

  <ng-content select="[fare-content]"></ng-content>

  <div *ngIf="divider" class="is-divider" data-content="OR"></div>
  <!-- Total  -->
  <div class="columns pt-2" *ngIf="!!totalTitle">
    <div class="column is-6" [class.m-1]="paddingless">
      <p class="weight-medium is-uppercase is-size-6">
        {{ totalTitle }}
      </p>
    </div>
    <div class="column is-6" [class.pr-4]="paddingless">
      <p
        class="weight-medium is-size-6 is-pulled-right py-1"
        [class.has-text-danger]="totalColorRed"
        [class.has-text-success]="totalColorGreen"
      >
        {{ totalValue?.currency }} {{ totalValue?.amount | currency : totalValue?.currency : 'symbol-narrow' : '1.2-2' : 'en-US' }}
      </p>
    </div>
  </div>
</div>
